import { Alert } from "PFComponents/alert";

import { BookingFormMode } from "../booking_form.types";
import { UpdateBookingsLabel } from "./update_bookings_label";
import { useBookingsErrorMessage } from "./use_bookings_error_message";

type FooterStatusMessageProps = {
  mode: BookingFormMode;
  dirtyBookingsIndexes: number[];
};

export const FooterStatusMessage = ({ mode, dirtyBookingsIndexes }: FooterStatusMessageProps) => {
  const errorMessage = useBookingsErrorMessage(mode, dirtyBookingsIndexes);

  if (errorMessage) {
    return <Alert kind="error" title={errorMessage} icon="error" multiLineTitle />;
  }

  return <UpdateBookingsLabel mode={mode} dirtyBookingsIndexes={dirtyBookingsIndexes} />;
};
